<template>
    <div class="confirmar_identidad">
        <v-container class="text-xs-center">
            <v-dialog
                    v-model="dialog_seguro"
                    persistent
                    width="300"
            >
                <v-card class="justify-center">
                    <v-card-title
                            class="warning display-1 text--primary justify-center"
                            primary-title
                    >
                        {{$t('aviso')}}
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                        <h4>{{$t('pgt_seguro')}}</h4>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" @click="dialog_seguro = false">No</v-btn>
                        <v-spacer/>
                        <v-btn color="primary" @click="eliminar_invitado()">{{$t('Si')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="dialog_bloqueo"
                    persistent
                    width="500"
            >
                <v-card class="justify-center">
                    <v-card-title
                            class="warning display-1 text--primary justify-center"
                            primary-title
                    >
                        {{$t('aviso')}}
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                        <h2>{{$t('pagina_caduca')}}</h2>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                large
                                to="/home"
                        >
                            <v-icon left>home</v-icon>
                            {{$t('inicio')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog" max-width="380">
                <v-card class="justify-center">
                    <v-card-title
                            class="warning display-1 text--primary justify-center"
                            primary-title
                    >
                        {{$t('confirmar_identidad')}}
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                        Selecciona <b>Sí</b> o <b>No</b>, para confirmar la Identidad.
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" @click="dialog = false">{{$t('aceptar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-layout calign-center justify-center fill-height>
                <v-card width="800">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('confirmar_identidad')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex
                                    class="edge pl-3 pr-3 pt-3 pb-3"
                                    xs12 sm6
                            >
                                <v-img
                                        v-if="info.length > 0"
                                        readonly
                                        outlined
                                        :src="info[0].avatar"
                                ></v-img>
                            </v-flex>
                            <v-flex
                                    class="edge pl-3 pr-3 pt-3 pb-3"
                                    xs12 sm6
                            >
                                <v-img
                                        v-if="info.length > 0"
                                        readonly
                                        outlined
                                        :src="info[0].ine_frente"
                                ></v-img>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <br>
                        <v-layout row wrap>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-if="info.length > 0"
                                        prepend-icon="mdi-account"
                                        :label="$t('Nombre')"
                                        :value="info[0].first_name"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-if="info.length > 0"
                                        prepend-icon="mdi-account-outline"
                                        :label="$t('Apellido')"
                                        :value="info[0].last_name"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-if="info.length > 0"
                                        prepend-icon="mdi-email"
                                        label="E-Mail"
                                        :value="info[0].email"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-if="info.length > 0"
                                        prepend-icon="mdi-cellphone"
                                        :label="$t('celular')"
                                        :value="info[0].celular"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        {{ $t('msg_know_guest') }}
                        <v-radio-group
                                class="justify-center"
                                row
                                v-model="confirmar"
                                name="confirmar"
                                :mandatory="false"
                        >
                            <v-radio outlined :label="$t('Si')" value=true></v-radio>
                            <v-radio outlined label="No" value=false></v-radio>
                        </v-radio-group>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                :loading="loading"
                                @click="confirmar_identidad()"
                        >
                            {{$t('enviar')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import store from '@/store'
    import { mapGetters } from 'vuex'

    export default {
        name: "confirmar_identidad",
        data () {
            return {
                confirmar: null,
                dialog: false,
                errores: [],
                info: '',
                loading: false,
                dialog_bloqueo: false,
                dialog_seguro: false
            }
        },
        created: async function(){
            // console.log('PATHHHHH = ', localStorage.getItem('path_confirmed'))
            //Obtener los Datos del Invitado
            await this.get_info_new_guest()
        },
        computed: {
            ...mapGetters(['getProfile'])
        },
        methods:{
            confirmar_identidad: function () {
                console.log('Confirmar Identidad = ', this.confirmar)
                if(this.confirmar == null){
                    this.dialog = true
                }
                if(this.confirmar == 'true'){
                    if (this.getProfile.roll === 4) {
                        this.loading = true
                        const config = {
                            method: 'patch',
                            url: 'https://empresa-service.intrare.app/InvitationPark/validate_guest/' + this.info[0].id,
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken,
                                'Accept-Language': this.language,
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                this.$router.push({ path: '/confirmar_exito' })
                            })
                            .catch(error => {
                                if(error.response && error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data){
                                    this.errores = error.response.data
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_color', 'error')
                                    this.$store.commit('snackbar_change_message', this.errores[0])
                                    setTimeout(this.clear, 3000)
                                }
                                else
                                if(error.response.status == 404)
                                {
                                    console.log(error.response.data.detail)
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_color', 'error')
                                    this.$store.commit('snackbar_change_message', error.response.data.detail)
                                    setTimeout(this.clear, 3000)
                                    this.$store.commit('snackbar_change_color', 'success')
                                    this.$store.commit('snackbar_activate_false')
                                }
                            })
                            .finally(() => (this.loading = false))
                    } else {
                        this.loading = true
                        const config = {
                            method: 'patch',
                            url: 'https://empresa-service.intrare.app/activateUser/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken,
                                'Accept-Language': this.language,
                            },
                            data:{
                                usrToken: this.$route.params['token']
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                this.$router.push({ path: '/confirmar_exito' })
                            })
                            .catch(error => {
                                if(error.response && error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data){
                                    this.errores = error.response.data
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_color', 'error')
                                    this.$store.commit('snackbar_change_message', this.errores[0])
                                    setTimeout(this.clear, 3000)
                                }
                                else
                                if(error.response.status == 404)
                                {
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_color', 'error')
                                    this.$store.commit('snackbar_change_message', this.errores[0])
                                    setTimeout(this.clear, 3000)
                                    this.$store.commit('snackbar_change_color', 'success')
                                    this.$store.commit('snackbar_activate_false')
                                }
                            })
                            .finally(() => (this.loading = false))
                    }
                }
                else
                if(this.confirmar == 'false'){
                    this.dialog_seguro = true
                }
            },
            eliminar_invitado(){
                //llamar al endpoint para eliminar usuario
                const config = {
                    method: 'POST',
                    url: 'https://empresa-service.intrare.app/NoActivateUser/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken,
                        'Accept-Language': this.language,
                    },
                    data:{
                        token: this.$route.params['token'],
                        cellNumber: this.info[0].celular
                    }
                }
                axios(config)
                .then(ok => {
                  console.log(ok)
                  this.$router.push({ path: '/confirmar_desconocido' })
                })
                .catch(error => {
                  console.log(error)
                })
            },
            get_info_new_guest: async function () {
                console.log('GET INFO NEW GUEST')
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getUser/' + this.$route.params['token'] + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                    },
                };
                axios(config)
                    .then(ok => {
                        this.info = ok.data
                        if(ok.data.length === 0){
                            this.dialog_bloqueo = true
                            console.log('Página Expirada .... overlay = ', this.dialog_bloqueo)
                        }
                    })
                    .catch(error => {
                        if(error.response && error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                        else
                        if(error.response.status == 404)
                        {
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_color', 'error')
                            this.$store.commit('snackbar_change_message', 'Token Inválido')
                            setTimeout(this.clear, 3000)
                        }
                    })
                    .finally(() => (this.loading = false))
            },
            clear(){
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
            }
        }
    }
</script>

<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }
    .edge {
        border-radius: 8px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
</style>
